import {MIN_ROUND_OFF_VALUE} from '../constants';

import type {Options} from './typedef';

export const round = (a: number, precision: number = 2): number =>
    Number(
        Math.round(Number(`${a}e+${precision}`))
        + `e-${precision}`,
    );
export const roundOff = (value: number): number => {
    if (value < 1 && value > 0) {
        return round(value);
    } else if (value < MIN_ROUND_OFF_VALUE) {
        return Math.round(value);
    }

    return value;
};
export const correctValue = (value: number, decimals: number): number => {
    const pow: number = 10 ** -decimals;

    if (value !== 0 && Math.abs(value) < pow) {
        value = pow * Math.sign(value);
    } else if (value === 0) {
        // make 0.0 from -0.0
        return Math.abs(value);
    }

    return value;
};
export const getDecimal = (
    decimals: number,
    value: string,
    options: Options,
): number => {
    if (options.threeDigit) {
        const MAX_DIGIT_COUNT = 3;
        return Math.max(MAX_DIGIT_COUNT - value.length, 0);
    }

    return decimals;
};
type TruncateTrailingZeros = (
    hideTrailingZeros: boolean
) => (match: string, separator: string, beforeZero: string) => string;
export const truncateTrailingZeros: TruncateTrailingZeros = hideTrailingZeros => (
    match,
    separator,
    beforeZero,
) => {
    if (hideTrailingZeros) {
        return beforeZero ? `${separator}${beforeZero}` : '';
    }

    return match;
};
